var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGreenLoanClean64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2695 26.7087V53.1118C13.2695 54.0946 14.0353 54.8914 14.9799 54.8914H51.1122C52.0568 54.8914 52.8226 54.0946 52.8226 53.1118V26.7087C52.8226 26.1905 52.6055 25.6981 52.2281 25.3601L34.162 9.17705C33.5205 8.60244 32.5716 8.60244 31.9301 9.17705L13.8639 25.3601C13.4865 25.6981 13.2695 26.1905 13.2695 26.7087Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7798 8.10352L52.0911 21.9321",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeDasharray: "6 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 28.2812V30.6523",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0928 28.2812V30.6523",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6201 45.9235H42.9302C44.0348 45.9235 44.9302 45.028 44.9302 43.9235V35.665",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8348 30.8514C48.8348 30.7409 48.7453 30.6514 48.6348 30.6514H41.9217C41.8112 30.6514 41.7217 30.7409 41.7217 30.8514V32.6273C41.7217 34.155 43.314 35.3935 45.2783 35.3935C47.2425 35.3935 48.8348 34.155 48.8348 32.6273V30.8514Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7744 49.3369H16.6292V52.4579C16.6292 53.7985 15.5424 54.8853 14.2018 54.8853C12.8612 54.8853 11.7744 53.7985 11.7744 52.4579V49.3369Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4194 49.3369H33.2742V52.4579C33.2742 53.7985 32.1874 54.8853 30.8468 54.8853C29.5062 54.8853 28.4194 53.7985 28.4194 52.4579V49.3369Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7255 36.2363L12.5 40.3211H32.9596L31.7342 36.2363C31.2266 34.5443 29.6693 33.3857 27.9029 33.3857H17.5568C15.7903 33.3857 14.233 34.5443 13.7255 36.2363Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0483 50.3779H9V44.4827C9 40.8763 12.4677 39.7435 14.2016 39.6279H30.8467C35.008 39.6279 36.0483 42.8644 36.0483 44.4827V50.3779Z",
    fill: "#1A7D1A",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3224 45.1763C17.3224 46.3255 16.3908 47.257 15.242 47.257C14.0927 47.257 13.1611 46.3255 13.1611 45.1763C13.1611 44.0272 14.0927 43.0957 15.242 43.0957C16.3908 43.0957 17.3224 44.0272 17.3224 45.1763Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8869 45.1763C31.8869 46.3255 30.9552 47.257 29.8064 47.257C28.6572 47.257 27.7256 46.3255 27.7256 45.1763C27.7256 44.0272 28.6572 43.0957 29.8064 43.0957C30.9552 43.0957 31.8869 44.0272 31.8869 45.1763Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGreenLoanClean64);
export default __webpack_public_path__ + "static/media/pictogramBeaconGreenLoanClean64.d3506244e9d748f0baedd842726470ba.svg";
export { ForwardRef as ReactComponent };